var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTotalcostsicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.342,
    height: 31.335,
    viewBox: "0 0 31.342 31.335",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1784",
    "data-name": "Group 1784",
    transform: "translate(-355.909 -974.082)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1783",
    "data-name": "Group 1783"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1767",
    "data-name": "Group 1767",
    transform: "translate(-484.24 -4240.712)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2046",
    "data-name": "Path 2046",
    d: "M870.741,5230.129a14.921,14.921,0,1,1-14.918-14.915A14.917,14.917,0,0,1,870.741,5230.129Z",
    transform: "translate(0 0.33)",
    fill: "#E4EAFF",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1769",
    "data-name": "Group 1769",
    transform: "translate(-762.608 -401)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1768",
    "data-name": "Group 1768",
    transform: "translate(1127.315 1383.315)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_77",
    "data-name": "Ellipse 77",
    cx: 4.722,
    cy: 1.259,
    rx: 4.722,
    ry: 1.259,
    transform: "translate(0)",
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2206",
    "data-name": "Path 2206",
    d: "M1136.943,1385.5v1.889c0,.7-2.113,1.259-4.722,1.259s-4.722-.564-4.722-1.259V1385.5",
    transform: "translate(-1127.5 -1384.241)",
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2207",
    "data-name": "Path 2207",
    d: "M1136.943,1388.5v1.889c0,.7-2.113,1.259-4.722,1.259s-4.722-.564-4.722-1.259V1388.5",
    transform: "translate(-1127.5 -1385.352)",
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_78",
    "data-name": "Ellipse 78",
    cx: 4.722,
    cy: 1.259,
    rx: 4.722,
    ry: 1.259,
    transform: "translate(5.036 8.184)",
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2208",
    "data-name": "Path 2208",
    d: "M1144.943,1398.5v1.889c0,.7-2.114,1.259-4.722,1.259s-4.722-.564-4.722-1.259V1398.5",
    transform: "translate(-1130.464 -1389.057)",
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2209",
    "data-name": "Path 2209",
    d: "M1144.943,1401.5v1.889c0,.7-2.114,1.259-4.722,1.259s-4.722-.564-4.722-1.259V1401.5",
    transform: "translate(-1130.464 -1390.168)",
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2210",
    "data-name": "Path 2210",
    d: "M1136.943,1391.5v1.889c0,.7-2.113,1.259-4.722,1.259s-4.722-.564-4.722-1.259V1391.5",
    transform: "translate(-1127.5 -1386.464)",
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2211",
    "data-name": "Path 2211",
    d: "M1127.5,1394.5v1.889c0,.7,2.114,1.259,4.722,1.259h.315",
    transform: "translate(-1127.5 -1387.575)",
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2212",
    "data-name": "Path 2212",
    d: "M1127.5,1397.5v1.889c0,.7,2.114,1.259,4.722,1.259h.315",
    transform: "translate(-1127.5 -1388.686)",
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_226",
    "data-name": "Line 226",
    y2: 1.259,
    transform: "translate(9.443 6.925)",
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_721",
    "data-name": "Rectangle 721",
    width: 15,
    height: 15,
    transform: "translate(1127 1383)",
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalcostsicon);
export default __webpack_public_path__ + "static/media/Total costs icon.8e28c571bcfa2170c06cb3296e1ba05f.svg";
export { ForwardRef as ReactComponent };